export function getFormattedSalaryCount(
  salaryCount: number | undefined,
): string {
  if (!salaryCount) return '0'

  // For counts less than 100, show the exact number
  if (salaryCount < 100) {
    return new Intl.NumberFormat('en-US').format(salaryCount)
  }

  // For counts in specific ranges, show the appropriate display format
  if (salaryCount >= 100 && salaryCount <= 249) return '100+'
  if (salaryCount >= 250 && salaryCount <= 499) return '250+'
  if (salaryCount >= 500 && salaryCount <= 999) return '500+'
  if (salaryCount >= 1000 && salaryCount <= 1999) return '1k+'
  if (salaryCount >= 2000 && salaryCount <= 4999) return '2k+'
  if (salaryCount >= 5000 && salaryCount <= 9999) return '5k+'
  if (salaryCount >= 10000 && salaryCount <= 24999) return '10k+'
  if (salaryCount >= 25000 && salaryCount <= 49999) return '25k+'
  if (salaryCount >= 50000 && salaryCount <= 99999) return '50k+'
  if (salaryCount >= 100000) return '100k+'

  // Fallback to formatted number if it doesn't match any range
  // (This shouldn't happen given the ranges cover all possibilities)
  return new Intl.NumberFormat('en-US').format(salaryCount)
}
